import { render, staticRenderFns } from "./navigationBlock.vue?vue&type=template&id=584f19ea&scoped=true"
import script from "./navigationBlock.vue?vue&type=script&lang=js"
export * from "./navigationBlock.vue?vue&type=script&lang=js"
import style0 from "./navigationBlock.vue?vue&type=style&index=0&id=584f19ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f19ea",
  null
  
)

export default component.exports